import { RecommendPlanResp } from 'app/bff/models/info/infoGetrecomplan';
import { InfoTravelregionQueryResp } from 'app/bff/models/info/infoTravelregionQuery';
import { ProductGetcoverageResp } from 'app/bff/models/product/productGetcoverage';
import { ProductGetkycquestionResp } from 'app/bff/models/product/productGetkycquestion';
import { ProductPolicyRulevalidateReq } from 'app/bff/models/product/productPolicyRulevalidate';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { PolicyTravelReq, PolicyTravelResp } from 'app/bff/models/policy/policyTravel';
import { PaymentCreditAuthReq } from 'app/bff/models/payment/paymentCreditAuth';
import { ProcessStepCodesEnum } from 'app/features/OnlineInsure/TravelInsurance/types';
import { FormValues as CalculationFormValues } from 'app/features/OnlineInsure/TravelInsurance/Calculation/types';
import { FormValues as InsuranceInfoFormValues } from 'app/features/OnlineInsure/TravelInsurance/InsuranceInfo/types';
import { FormValues as InsuranceInfoClausesFormValues } from 'app/features/OnlineInsure/TravelInsurance/InsuranceInfo/Clauses/types';

// State type
export interface TravelInsuranceState {
  recommendPlanData?: RecommendPlanResp;
  static: StaticState;
  process: ProcessState;
  policyInfo?: PolicyInfoState;
  policyStatus?: PolicyStatusState;
}

interface StaticState {
  travelRegions: InfoTravelregionQueryResp['geoCountrys'];
  coverages: ProductGetcoverageResp['coverageTravel'];
  questionnaires: ProductGetkycquestionResp['questionnaires'];
  paymentWSUUID?: string;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  calculation: {
    data?: CalculationFormValues;
  };
  insuranceInfo: {
    data?: InsuranceInfoFormValues;
    clauses: {
      data?: InsuranceInfoClausesFormValues;
    };
  };
  confirmInfo: {
    otpAuth: {
      approvedTime?: string;
      otp?: AaOtpSendcodeResp;
    };
  };
}

interface PolicyInfoState extends PolicyTravelResp {
  premiumTotal: number;
}

interface PolicyStatusState {
  isAudit?: boolean;
  isUnpaid?: boolean;
  paymentDeadline?: string;
}
// ::: End

// Actions type constant
export const INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA = 'INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA';
export const INSURE_TRAVEL_INSURANCE__INIT_PROCESS = 'INSURE_TRAVEL_INSURANCE__INIT_PROCESS';
export const INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE = 'INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE';
export const INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP = 'INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP';
export const INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA = 'INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA';
export const INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULES = 'INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULES';
export const INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULE_LAUNDERING_LIST = 'INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULE_LAUNDERING_LIST';
export const INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS = 'INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS';
export const INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA = 'INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA';
export const INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA = 'INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA';
export const INSURE_TRAVEL_INSURANCE__SEND_OTP = 'INSURE_TRAVEL_INSURANCE__SEND_OTP';
export const INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE = 'INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE';
export const INSURE_TRAVEL_INSURANCE__RESEND_OTP = 'INSURE_TRAVEL_INSURANCE__RESEND_OTP';
export const INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE = 'INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE';
export const INSURE_TRAVEL_INSURANCE__AUTH_OTP = 'INSURE_TRAVEL_INSURANCE__AUTH_OTP';
export const INSURE_TRAVEL_INSURANCE__SEND_POLICY = 'INSURE_TRAVEL_INSURANCE__SEND_POLICY';
export const INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE = 'INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE';
export const INSURE_TRAVEL_INSURANCE__EXECUTE_CREDIT_CARD_PAYMENT = 'INSURE_TRAVEL_INSURANCE__EXECUTE_CREDIT_CARD_PAYMENT';
export const INSURE_TRAVEL_INSURANCE__UPDATE_CACHE = 'INSURE_TRAVEL_INSURANCE__UPDATE_CACHE';
export const INSURE_TRAVEL_INSURANCE__RESET_CACHE = 'INSURE_TRAVEL_INSURANCE__RESET_CACHE';
// ::: End

// Action creators type
export interface SaveRecommendPlanDataAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA;
  payload: {
    data: RecommendPlanResp;
  };
}

export interface InitProcessAction {
  type: typeof INSURE_TRAVEL_INSURANCE__INIT_PROCESS;
}

export interface InitProcessDoneAction {
  type: typeof INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE;
  payload: {
    response: TravelInsuranceState['static'];
  };
}

export interface SetAccessibleStepAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface SaveCalculationPageDataAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA;
  payload: {
    data: CalculationFormValues;
  };
}

export interface ValidatePolicyRulesAction {
  type: typeof INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULES;
  payload: {
    args: ProductPolicyRulevalidateReq;
    data: InsuranceInfoFormValues;
  };
}

export interface ValidatePolicyRuleLaunderingListAction {
  type: typeof INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULE_LAUNDERING_LIST;
  payload: {
    args: ProductPolicyRulevalidateReq;
    data: InsuranceInfoFormValues;
  };
}

export interface SetPolicyStatusAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS;
  payload: {
    status: TravelInsuranceState['policyStatus'];
  };
}

export interface SaveInsuranceInfoPageDataAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA;
  payload: {
    data: InsuranceInfoFormValues;
  };
}

export interface SaveInsuranceInfoClausesPageDataAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA;
  payload: {
    data: InsuranceInfoClausesFormValues;
  };
}

export interface SendOTPAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface SendOTPDoneAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface ResendOTPAction {
  type: typeof INSURE_TRAVEL_INSURANCE__RESEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface ResendOTPDoneAction {
  type: typeof INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthOTPAction {
  type: typeof INSURE_TRAVEL_INSURANCE__AUTH_OTP;
  payload: {
    authOTPArgs: AaOtpVerifyReq;
    policyArgs: any;
  };
}

export interface SendPolicyAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SEND_POLICY;
  payload: {
    args: PolicyTravelReq;
  };
}

export interface SendPolicyDoneAction {
  type: typeof INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE;
  payload: {
    premiumTotal: number;
    response: PolicyTravelResp;
  };
}

export interface ExecuteCreditCardPaymentAction {
  type: typeof INSURE_TRAVEL_INSURANCE__EXECUTE_CREDIT_CARD_PAYMENT;
  payload: {
    args: PaymentCreditAuthReq;
  };
}

export interface UpdateCacheAction {
  type: typeof INSURE_TRAVEL_INSURANCE__UPDATE_CACHE;
  payload: {
    cache: TravelInsuranceState;
  };
}

export interface ResetCacheAction {
  type: typeof INSURE_TRAVEL_INSURANCE__RESET_CACHE;
}

export type TravelInsuranceActions =
    SaveRecommendPlanDataAction
  | InitProcessAction
  | InitProcessDoneAction
  | SetAccessibleStepAction
  | SaveCalculationPageDataAction
  | ValidatePolicyRulesAction
  | ValidatePolicyRuleLaunderingListAction
  | SetPolicyStatusAction
  | SaveInsuranceInfoPageDataAction
  | SaveInsuranceInfoClausesPageDataAction
  | SendOTPAction
  | SendOTPDoneAction
  | ResendOTPAction
  | ResendOTPDoneAction
  | AuthOTPAction
  | SendPolicyAction
  | SendPolicyDoneAction
  | ExecuteCreditCardPaymentAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
